<template>
  <div v-if="items.length" class="row q-gutter-x-sm q-gutter-y-md wrap">
    <common-chip v-if="leadingItem" :label="leadingItem.title" filled/>
    <common-chip
        v-for="item in filteredItems"
        :key="item.id"
        :label="item.title"
    />
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: null
    },
    leadingItem: {
      type: Object,
      default: null
    }
  },
  computed: {
    filteredItems(){
      if(!this.leadingItem) {
        return this.items
      }

      return this.items.filter((item) => {
        return item.id !== this.leadingItem.id
      })
    }
  }
}
</script>
